import { LoadingSpinner, StyledButton } from './styles';
import { ButtonProps } from './types';

export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled,
  children,
  ...props
}: ButtonProps) {
  return (
    <StyledButton
      disabled={disabled || loading}
      data-testid="button"
      variantType={variant}
      sizeType={size}
      {...props}
    >
      {loading && <LoadingSpinner />}
      {children}
    </StyledButton>
  );
}
